<ngx-spinner size="large"></ngx-spinner>
<ngx-one-column-dau-tu-layout>
    <nb-menu [items]="menu"></nb-menu>
    <router-outlet></router-outlet>
</ngx-one-column-dau-tu-layout>